<template>
    <div v-if="ToutesLesCondamnation.length ==0" class="container-fluid messageAlerte frame-messageAlerteEleve" role="alert">
		<div class="container">
			<div class="row">
				<div class="col-12 col-md-12 d-flex flex-row">
					<div><p>La liste des condamnations n'est pas disponible pour le moment.</p></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default{
        name:"Donnees_non_disponible",
        components: {
    
        },
        props: {

        ToutesLesCondamnation: {
          type: Array
	    },
      
	    },
        data(){
          return{
    
          }
        }, 
        methods:{

        },
        computed: {
    
        }
    }
</script>

<style scoped>
    .frame-messageAlerteEleve, .frame-messageAlerteModere {
        color: #223654;
        font-weight: 600;
        padding-top: 24px;
        padding-bottom: 24px;
        font-family: Open Sans;
        font-size : 16px;
        font-weight:500;
    }
    .frame-messageAlerteEleve p, .frame-messageAlerteModere p{
        margin-bottom:0;
    }

    .frame-messageAlerteEleve {
        background-color: #f8e69a;
    }
    .frame-messageAlerteModere {
        background-color: #D9E6F0;
    }
    .frame-messageAlerteModere .container .row,.frame-messageAlerteEleve .container .row{
        margin-left: 24px!important;
    }
    .frame-messageAlerteModere .container,.frame-messageAlerteEleve .container{
        background-size: 24px 24px;
        background-position: 0.5rem 0rem;
        background-repeat: no-repeat;
    }
    .frame-messageAlerteEleve .container{
        background-image: url(../../public/img/avis-important.svg);
    }
</style>